import React from 'react';
import { MoreVertical, X, Edit } from 'lucide-react';
interface OpenOrder {
  market: string;
  side: 'Buy' | 'Sell';
  type: string;
  currentPrice: string;
  limitPrice: string;
  quantity: string;
  progress: string;
  dateTime: string;
  leverage: string;
  reduceOnly?: boolean;
}
const mockOrders: OpenOrder[] = [{
  market: 'BTC/USD',
  side: 'Sell',
  type: 'Limit',
  currentPrice: '95,659.8',
  limitPrice: '128,000.0',
  quantity: '0.00082670',
  progress: '0.00%',
  dateTime: '1/16/26 10:33 AM',
  leverage: '10x',
  reduceOnly: true
}];
export function OpenOrdersTable() {
  if (mockOrders.length === 0) {
    return <div className="flex flex-col items-center justify-center h-full py-16" data-id="element-2014">
        <div className="w-12 h-12 rounded-full bg-background-elevated flex items-center justify-center mb-3" data-id="element-2015">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-text-tertiary" data-id="element-2016">
            <rect x="3" y="3" width="7" height="7" data-id="element-2017" />
            <rect x="14" y="3" width="7" height="7" data-id="element-2018" />
            <rect x="14" y="14" width="7" height="7" data-id="element-2019" />
            <rect x="3" y="14" width="7" height="7" data-id="element-2020" />
          </svg>
        </div>
        <p className="text-sm text-text-secondary" data-id="element-2021">No open orders.</p>
      </div>;
  }
  return <div className="h-full overflow-auto" data-id="element-2022">
      <table className="w-full min-w-[800px]" data-id="element-2023">
        <thead className="sticky top-0 z-10" data-id="element-2024">
          <tr className="border-b border-border-subtle" data-id="element-2025">
            <th className="text-left px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-2026">
              Market
            </th>
            <th className="text-left px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-2027">
              Side
            </th>
            <th className="text-left px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-2028">
              Type
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-2029">
              Current Price
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-2030">
              Limit Price
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-2031">
              Quantity
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-2032">
              Progress
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-2033">
              Date & Time
            </th>
            <th className="text-right px-3 py-2" data-id="element-2034"></th>
          </tr>
        </thead>
        <tbody data-id="element-2035">
          {mockOrders.map((order, idx) => <tr key={idx} className="border-b border-border-subtle hover:bg-background-elevated transition-colors group" data-id="element-2036">
              <td className="px-3 py-2" data-id="element-2037">
                <div className="flex items-center gap-2" data-id="element-2038">
                  <img src="https://cryptologos.cc/logos/bitcoin-btc-logo.svg" alt="BTC" className="w-5 h-5" data-id="element-2039" />
                  <span className="text-xs text-text-primary font-medium" data-id="element-2040">
                    {order.market}
                  </span>
                  <span className="text-[10px] text-text-tertiary bg-background-elevated px-1 py-0.5 rounded" data-id="element-2041">
                    {order.leverage}
                  </span>
                </div>
              </td>
              <td className="px-3 py-2" data-id="element-2042">
                <div className="flex items-center gap-1.5" data-id="element-2043">
                  <span className={`text-xs font-medium ${order.side === 'Buy' ? 'text-success' : 'text-danger'}`} data-id="element-2044">
                    {order.side}
                  </span>
                  {order.reduceOnly && <span className="text-[10px] text-text-tertiary" data-id="element-2045">
                      (Reduce)
                    </span>}
                </div>
              </td>
              <td className="px-3 py-2" data-id="element-2046">
                <span className="text-xs text-text-primary" data-id="element-2047">{order.type}</span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2048">
                <span className="font-mono text-xs text-text-primary" data-id="element-2049">
                  {order.currentPrice}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2050">
                <span className="font-mono text-xs text-text-primary" data-id="element-2051">
                  {order.limitPrice}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2052">
                <span className="font-mono text-xs text-text-primary" data-id="element-2053">
                  {order.quantity}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2054">
                <span className="font-mono text-xs text-text-primary" data-id="element-2055">
                  {order.progress}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2056">
                <span className="text-xs text-text-secondary" data-id="element-2057">
                  {order.dateTime}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2058">
                <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-2059">
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-text-primary" data-id="element-2060">
                    <Edit size={14} data-id="element-2061" />
                  </button>
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-text-primary" data-id="element-2062">
                    <MoreVertical size={14} data-id="element-2063" />
                  </button>
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-danger" data-id="element-2064">
                    <X size={14} data-id="element-2065" />
                  </button>
                </div>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}